export default __webpack_public_path__ + "static/media/florayfauna1.54f28b7b.jpg";